import React from 'react';
import { components } from 'react-select';
const MenuPortalComponent = components.MenuPortal;

const MenuPortal = (props) => (
  <MenuPortalComponent className="ws-ui-base-select-menu-portal" {...props} />
);

export default MenuPortal;
